import { Snackbar as MuiSnackbar, Alert } from "@mui/material";
import PropTypes from "prop-types";

const Snackbar = ({ snack, onClose }) => {
  const handleClose = () => onClose();

  return (
    <MuiSnackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      autoHideDuration={6000}
      open={snack.open}
      onClose={handleClose}
    >
      <Alert variant="filled" severity={snack.type} onClose={handleClose}>
        {snack.message}
      </Alert>
    </MuiSnackbar>
  );
};

Snackbar.propTypes = {
  snack: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

export default Snackbar;
